import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyOrderLineItemKey,
  ShopifyRequestedOrderEditKey,
  ShopifyRequestedOrderEditLineItemKey,
  ShopifyRequestedOrderEditLineItemToOrderLineItemKey,
  ShopifyRequestedOrderEditLineItemToRequestedOrderEditKey,
  ShopifyRequestedOrderEditLineItemToShopKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyRequestedOrderEditLineItemKey,
  "2026-10": {
    name: "Shopify Requested Order Edit Line Item",
    graphQLTypename: "RequestedOrderEditLineItem",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "id",
            shopifyFieldKey: "id",
            availableInWebhook: ["requested_order_edit/created", "requested_order_edit/resolved", "requested_order_edit/declined"],
          },
        },
      },
      {
        name: "Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "quantity",
            shopifyFieldKey: "quantity",
            availableInWebhook: ["requested_order_edit/created", "requested_order_edit/resolved", "requested_order_edit/declined"],
          },
        },
      },
      {
        name: "Resolved Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "resolvedQuantity",
            shopifyFieldKey: "resolved_quantity",
            availableInWebhook: ["requested_order_edit/created", "requested_order_edit/resolved", "requested_order_edit/declined"],
          },
        },
      },
      {
        name: "Order Line Item",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRequestedOrderEditLineItemToOrderLineItemKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "lineItem",
            shopifyFieldKey: "line_item_id",
            availableInWebhook: ["requested_order_edit/created", "requested_order_edit/resolved", "requested_order_edit/declined"],
            graphQLSelection: "id",
          },
        },
        configuration: { relatedModelKey: ShopifyOrderLineItemKey },
      },
      {
        name: "Requested Order Edit",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRequestedOrderEditLineItemToRequestedOrderEditKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "requestedOrderEdit",
            shopifyFieldKey: "requested_order_edit_id",
            skipGraphQLSelection: true,
          },
        },
        configuration: { relatedModelKey: ShopifyRequestedOrderEditKey },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyRequestedOrderEditLineItemToShopKey,
        configuration: { relatedModelKey: ShopifyShopKey },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "order.requestedOrderEdits",
      resource: "requestedOrderEdit.lineItems.removals",
      parentNodeType: "RequestedOrderEdit",
    },
  },
};

export const ShopifyRequestedOrderEditLineItem = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
